import React, { Component } from "react";
import { propertyUtil } from "views/Pma/PropertyUtil";
import "./print.scss";

// const BACKGROUND_SRC =
//   "https://d2onbxnrte2nim.cloudfront.net/non-covers/083026_Table-HotBoxes_Pg3-bg_1.png";

const getSixMonthAvgSalePrice = (quarterlyTable) => {
  if (!quarterlyTable) return null;
  const trends = quarterlyTable.marketTrends;
  if (Array.isArray(trends)) {
    const sixMonth = trends.find(
      (trend) => trend.TrendName === "6-Months Trending",
    );
    if (sixMonth && sixMonth.AvgSalePrice != null) {
      return sixMonth.AvgSalePrice;
    }
  }
  const fromHighlights =
    quarterlyTable.marketHighLightsData &&
    quarterlyTable.marketHighLightsData.current180DaysAvgSalePrice;
  if (
    fromHighlights != null &&
    fromHighlights !== "" &&
    fromHighlights !== "0"
  ) {
    return fromHighlights;
  }
  return null;
};

class BottomHotBoxes extends Component {
  formatPrice = (value) => {
    const { roundSalePrice } = propertyUtil;
    if (value == null || value === "" || value === "0") {
      return "—";
    }
    return roundSalePrice(value);
  };

  formatCityName = () => {
    const { currentArea } = this.props;
    const { capitalizeWords } = propertyUtil;
    const cityName = currentArea && currentArea.mlsCityName;
    if (!cityName) return "Your City";
    return capitalizeWords(cityName);
  };

  render() {
    const {
      quarterlyCityTable,
      quarterlyAreaTable,
      printVersion,
      currentArea,
      agentData,
    } = this.props;
    const { mlsAreaID, mlsNeighborhood } = currentArea;
    const { listgenUserID } = agentData;
    let cityPrice = this.formatPrice(
      getSixMonthAvgSalePrice(quarterlyCityTable),
    );
    const neighborhoodRaw = getSixMonthAvgSalePrice(quarterlyAreaTable);
    let neighborhoodPrice = this.formatPrice(neighborhoodRaw);

    const neighborhoodPriceText =
      neighborhoodPrice == null ? "" : String(neighborhoodPrice).trim();
    const neighborhoodRawText =
      neighborhoodRaw == null ? "" : String(neighborhoodRaw).trim();
    let showNeighborhood = !(
      neighborhoodRaw == null ||
      neighborhoodRaw === 0 ||
      neighborhoodRawText === "" ||
      neighborhoodRawText === "0" ||
      neighborhoodRawText === "-" ||
      neighborhoodRawText === "—" ||
      neighborhoodPriceText === "" ||
      neighborhoodPriceText === "0" ||
      neighborhoodPriceText === "-" ||
      neighborhoodPriceText === "—"
    );
    let contentClasses = "";
    if (
      mlsAreaID === "NPA-E0600A" ||
      mlsAreaID === "NPA-E1200A" ||
      listgenUserID === "113599" ||
      mlsAreaID === "37A" ||
      mlsAreaID === "39A"
      // listgenUserID === "100138"
    ) {
      showNeighborhood = false;
    }
    if (!showNeighborhood || !neighborhoodPrice) {
      contentClasses = "centered-hot-boxes-content";
    }

    // const BACKGROUND_SRC =
    //   "https://d2onbxnrte2nim.cloudfront.net/non-covers/083026_Table-HotBoxes_Pg3-bg_04.png";

    const BACKGROUND_SRC = showNeighborhood
      ? "https://d2onbxnrte2nim.cloudfront.net/non-covers/083026_Table-HotBoxes_Pg3-bg_04.png"
      : "https://d2onbxnrte2nim.cloudfront.net/non-covers/090826_HotBox_Pg3-bg_06.png";
    let cityName = this.formatCityName();
    let neighborhoodName = "Your Neighborhood";
    let disclaimer =
      "The average sale prices shown above are calculated from the past 6 months of sales.";
    if (showNeighborhood == false) {
      disclaimer =
        "The average sale price shown above is calculated from the past 6 months of sales.";
    }
    let cityNameClass = "";
    let neighborhoodNameClass = "";
    if (mlsAreaID === "36A") {
      neighborhoodName = mlsNeighborhood;
    }
    return (
      <div
        className={
          printVersion ? "print-bottom-hot-boxes" : "editor-bottom-hot-boxes"
        }
      >
        <img src={BACKGROUND_SRC} alt="" className="bottom-hot-boxes-bg" />
        <div className={`bottom-hot-boxes-content ${contentClasses}`}>
          <div className="bottom-hot-boxes-col">
            <div className={`bottom-hot-boxes-label ${cityNameClass}`}>
              {cityName}
            </div>
            <div className="bottom-hot-boxes-price">{cityPrice}</div>
          </div>
          {showNeighborhood && (
            <div className="bottom-hot-boxes-col">
              <div
                className={`bottom-hot-boxes-label ${neighborhoodNameClass}`}
              >
                {neighborhoodName}
              </div>
              <div className="bottom-hot-boxes-price">{neighborhoodPrice}</div>
            </div>
          )}
        </div>
        <div className="bottom-hot-boxes-disclaimer">{disclaimer}</div>
      </div>
    );
  }
}

export default BottomHotBoxes;
